import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-indigo-900 to-purple-900 text-white py-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">
            Privacy Policy
          </h1>
          <p className="text-xl text-gray-300">
            Last Updated: 2025
          </p>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-gray-700 mb-12 leading-relaxed">
              CrowdRounds is committed to protecting your privacy. This policy explains how your data is collected and used.
            </p>

            <div className="space-y-12">
              {/* Section 1 */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <span className="w-10 h-10 bg-indigo-500 text-white rounded-full flex items-center justify-center text-lg flex-shrink-0">1</span>
                  Information We Collect
                </h2>
                <div className="ml-13 space-y-3">
                  <p className="text-gray-700 text-lg leading-relaxed flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-indigo-500 text-xl mt-1 flex-shrink-0"></i>
                    <span>App name, links, description, and category</span>
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-indigo-500 text-xl mt-1 flex-shrink-0"></i>
                    <span>Contact information (name, email)</span>
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-indigo-500 text-xl mt-1 flex-shrink-0"></i>
                    <span>Submission form responses</span>
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-indigo-500 text-xl mt-1 flex-shrink-0"></i>
                    <span>Payment information (handled securely by our payment processor)</span>
                  </p>
                </div>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <span className="w-10 h-10 bg-indigo-500 text-white rounded-full flex items-center justify-center text-lg flex-shrink-0">2</span>
                  How We Use Your Data
                </h2>
                <div className="ml-13 space-y-3">
                  <p className="text-gray-700 text-lg leading-relaxed flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-indigo-500 text-xl mt-1 flex-shrink-0"></i>
                    <span>To generate your app evaluation</span>
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-indigo-500 text-xl mt-1 flex-shrink-0"></i>
                    <span>To deliver your report</span>
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-indigo-500 text-xl mt-1 flex-shrink-0"></i>
                    <span>To provide updates on your submission</span>
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-indigo-500 text-xl mt-1 flex-shrink-0"></i>
                    <span>To improve our intelligence systems</span>
                  </p>
                </div>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <span className="w-10 h-10 bg-indigo-500 text-white rounded-full flex items-center justify-center text-lg flex-shrink-0">3</span>
                  Data Protection
                </h2>
                <div className="ml-13 space-y-3">
                  <p className="text-gray-700 text-lg leading-relaxed">
                    We do not sell personal data.
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    We use secure systems to protect your information.
                  </p>
                </div>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <span className="w-10 h-10 bg-indigo-500 text-white rounded-full flex items-center justify-center text-lg flex-shrink-0">4</span>
                  Cookies &amp; Tracking
                </h2>
                <p className="text-gray-700 text-lg leading-relaxed ml-13">
                  Used only to improve site performance and user experience.
                </p>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <span className="w-10 h-10 bg-indigo-500 text-white rounded-full flex items-center justify-center text-lg flex-shrink-0">5</span>
                  Third-Party Services
                </h2>
                <p className="text-gray-700 text-lg leading-relaxed ml-13">
                  Payments and processing may involve trusted partners like Stripe or PayPal.
                </p>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <span className="w-10 h-10 bg-indigo-500 text-white rounded-full flex items-center justify-center text-lg flex-shrink-0">6</span>
                  Contact
                </h2>
                <p className="text-gray-700 text-lg leading-relaxed ml-13">
                  Questions? Email: <a href="mailto:support@crowdrounds.org" className="text-indigo-600 hover:text-indigo-700 font-semibold cursor-pointer">support@crowdrounds.org</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
